// extracted by mini-css-extract-plugin
module.exports = {"Tick":"CompleteTick-Tick-1KvOG9","draw":"CompleteTick-draw-1ojsqa"};